export const GATSBY_ENVS = [
  "development",
  "test",
  "staging",
  "production",
] as const;
export type GatsbyEnv = typeof GATSBY_ENVS[number];

export function isGatsbyEnv(value: any): value is GatsbyEnv {
  return GATSBY_ENVS.includes(value);
}

export function getGatsbyEnv() {
  const gatsbyEnv = process.env.GATSBY_ENV || "development";
  if (!isGatsbyEnv(gatsbyEnv)) {
    throw Error(
      `The environment variable GATSBY_ENV must be one of ${GATSBY_ENVS}. ` +
        `Provided value was "${process.env.GATSBY_ENV}".`
    );
  }

  return gatsbyEnv;
}

/**
 * In staging, HOSTNAME looks like `staging-1.taskrabbit.in`.
 * In production, HOSTNAME looks like `v3-web-1.taskrabbit.net`.
 */
export function getHostname() {
  const hostname = process.env.HOSTNAME;
  const environment = getGatsbyEnv();

  if (environment === "staging") {
    if (!hostname) {
      throw Error(
        "The environment variable HOSTNAME is required when building for staging."
      );
    }
    return hostname;
  }

  throw Error(
    "Hostname should not be needed in any environment except staging."
  );
}

export function getLimitNodeDownloads() {
  if (process.env.LIMIT_NODE_DOWNLOADS === "true") {
    return true;
  }
  if (process.env.LIMIT_NODE_DOWNLOADS === "false") {
    return false;
  }
  throw Error(
    `The environment variable LIMIT_NODE_DOWNLOADS must ` +
      `be either "true" or "false". Provided value was ` +
      `"${process.env.LIMIT_NODE_DOWNLOADS}".`
  );
}

export function getBugsnagApiKey() {
  const environmentVariable = process.env.GATSBY_BUGSNAG_API_KEY;
  if (environmentVariable == null) {
    throw Error("The environment variable GATSBY_BUGSNAG_API_KEY is required.");
  }
  return environmentVariable;
}

export function getFacebookAppId() {
  const environmentVariable = process.env.GATSBY_FACEBOOK_APP_ID;
  if (environmentVariable == null) {
    throw Error("The environment variable GATSBY_FACEBOOK_APP_ID is required.");
  }
  return environmentVariable;
}
